// extracted by mini-css-extract-plugin
export default {"link":"LocalAuthDisabledError_link__riMaN"};